import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

import { CriterionByTargetingTag } from './criterion-by-targeting-tag'
export const GetChatMaterialsRequest = z.object({
  agentId: z.string(),
  calibrationId: z.string().optional(),
})

export type GetChatMaterialsRequest = z.infer<typeof GetChatMaterialsRequest>

export const GetChatMaterialsResponse = z.object({
  calibrationId: z.string(),
  icpCriterion: CriterionByTargetingTag,
  questions: z.array(
    z.object({
      questionText: z.string(),
      options: z.array(
        z.object({
          optionText: z.string(),
          score: z.number(),
        }),
      ),
      type: z.literal('multiChoice'),
      weight: z.number(),
    }),
  ),
})

export type GetChatMaterialsResponse = z.infer<typeof GetChatMaterialsResponse>

export const getChatMaterialsDeclaration = endpointDeclaration(GetChatMaterialsRequest, GetChatMaterialsResponse)
